import { Loader } from 'components/Loader';
import { useGetOrganizationUsersQuery } from 'data/__generated__';

import { EmbeddedUsersTable } from 'pages/Users/components/EmbeddedUsersTable';

// Self-fetching single table of every user attached to an organization. Used on the totem details page
// (the totem's users = the users of its organization).
export const OrganizationUsersTable = ({
    organizationId,
    emptyMessage,
}: {
    organizationId: string;
    emptyMessage?: string;
}) => {
    const { loading, error, data } = useGetOrganizationUsersQuery({
        variables: { organizationId },
        skip: !organizationId,
    });

    if (loading) {
        return (
            <div className="flex min-h-[200px] w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (error || !data) {
        throw new Error('Une erreur est survenue lors de la récupération des utilisateurs');
    }

    return <EmbeddedUsersTable users={data.organizationUsers} emptyMessage={emptyMessage} />;
};
